module.exports = __webpack_public_path__ + "media/styles/images/png/circle-ex-gray-on-white-93b1f26142ff6f87b7a2be25cc49aa79.png";